import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RefundActions } from './actions/refund.actions';

@NgModule( {
    declarations: [],
    imports: [
        CommonModule
    ],
    providers: [ RefundActions ]
} )
export class RefundModule { }
